import { GenericFormType } from "components/forms/GenericForm";
import { useTranslations } from "hooks";

export const useRegistrationFormSchema = (): GenericFormType => {
    const [EMAIL, NAME, FIRSTNAME, FUNCTION, ORGA, ACTIVITY, COUNTRY] =
        useTranslations(i18n);
    const [
        MANUFACTURING,
        SALES,
        PURCHASE,
        TOXICOLOGY,
        CEO,
        REGULATORY,
        IT,
        EHS,
        RD,
        QUALITY,
    ] = useTranslations(i18n_jobs);
    const [
        FOOD_PROCESSING_SEED_FRUIT_VEGETABLES,
        FOOD_PROCESSING_DAIRY,
        FOOD_PROCESSING_SUGAR_INDUSTRY,
        FOOD_PROCESSING_GENERAL,
        FOOD_PROCESSING_ANIMAL_FEEDINGSTUFFS,
        COSMETICS,
        HOME_CARE_DETERGENT_BIOCIDES_CANDLES,
        TOBACCO_ELIQUID,
        LARGE_SCALE_RETAILING,
        CHEMICALS_FINE_CHEMICALS,
        CHEMICALS_PAINT_COATING,
        CHEMICALS_PETROCHEMISTRY,
        CHEMICALS_PLASTICS,
        CHEMICALS_METALLURGY_CERAMICS,
        CHEMICALS_FLAVOURING_FRAGRANCE,
        CHEMICALS_EXPLOSIVE,
        TRANSPORT_AEROSPACE,
        TRANSPORT_AUTOMOTIVE,
        HEALTH_PHARMACEUTICAL_MD,
        HEALTH_DIAGNOSIS_TEST_LABORATORY,
        DEFENCE_ARMAMENT_SECURITY,
        ENERGY,
        ENVIRONMENT_RECYCLING,
        ENVIRONMENT_WATER_TREATMENT,
        CONSTRUCTION_MATERIALS,
        CONSTRUCTION_BUILDING_AND_PUBLIC_WORKS_INDUSTRY,
        ELECTRICAL_APPLIANCES,
        TELECOMMUNICATIONS,
        ELECTRONICS,
        TRANSPORT_RAILWAYS,
        TEXTILE,
    ] = useTranslations(i18n_activity);

    return {
        className: "sform field2-s field3-s",
        schema: {
            btnSubmit: {
                id: "submitFormRegistrationButton",
                text: "envoyer et voir mon resulat",
                className: "mdBtn-form",
            },
            type: "object",
            required: [
                "email",
                "firstName",
                "lastName",
                "job",
                "organization",
                "activityArea",
                "country",
            ],
            properties: {
                email: {
                    type: "string",
                    title: `${EMAIL}`,
                    pattern:
                        process.env.REACT_APP_DISABLE_EMAIL_EXTENDS === "true"
                            ? "^\\s*[a-zA-Z0-9\\._-]+@[a-zA-Z0-9\\.-]+\\.[a-zA-Z]{2,4}\\s*|\\s*[a-zA-Z0-9\\._%+-]+@ecomundo\\.eu\\s*$" // Excluding aliases mail such as test+123@gmail.com
                            : "^\\s*[a-zA-Z0-9\\._%+-]+@[a-zA-Z0-9\\.-]+\\.[a-zA-Z]{2,4}\\s*$",
                },
                lastName: {
                    type: "string",
                    title: `${NAME}`,
                },
                firstName: {
                    type: "string",
                    title: `${FIRSTNAME}`,
                },
                job: {
                    type: "string",
                    title: `${FUNCTION}`,
                    anyOf: [
                        {
                            type: "string",
                            title: MANUFACTURING,
                            enum: ["manufacturing"],
                        },
                        {
                            type: "string",
                            title: SALES,
                            enum: ["sales-export"],
                        },
                        {
                            type: "string",
                            title: PURCHASE,
                            enum: ["purchase-supply-chain-finance"],
                        },
                        {
                            type: "string",
                            title: TOXICOLOGY,
                            enum: ["toxicology"],
                        },
                        {
                            type: "string",
                            title: CEO,
                            enum: ["ceo-general-manager"],
                        },
                        {
                            type: "string",
                            title: REGULATORY,
                            enum: ["regulatory-affairs"],
                        },
                        {
                            type: "string",
                            title: IT,
                            enum: ["it-system-department"],
                        },
                        {
                            type: "string",
                            title: EHS,
                            enum: ["ehs"],
                        },
                        {
                            type: "string",
                            title: RD,
                            enum: ["r-d"],
                        },
                        {
                            type: "string",
                            title: QUALITY,
                            enum: ["quality"],
                        },
                    ],
                },
                organization: {
                    type: "string",
                    title: `${ORGA}`,
                },
                activityArea: {
                    type: "string",
                    title: `${ACTIVITY}`,
                    anyOf: [
                        {
                            type: "string",
                            title: FOOD_PROCESSING_SEED_FRUIT_VEGETABLES,
                            enum: [
                                formatActivity(
                                    "FOOD_PROCESSING_SEED_FRUIT_VEGETABLES"
                                ),
                            ],
                        },
                        {
                            type: "string",
                            title: FOOD_PROCESSING_DAIRY,
                            enum: [formatActivity("FOOD_PROCESSING_DAIRY")],
                        },
                        {
                            type: "string",
                            title: FOOD_PROCESSING_SUGAR_INDUSTRY,
                            enum: [formatActivity("FOOD_PROCESSING_SUGAR_INDUSTRY")],
                        },
                        {
                            type: "string",
                            title: FOOD_PROCESSING_GENERAL,
                            enum: [formatActivity("FOOD_PROCESSING_GENERAL")],
                        },
                        {
                            type: "string",
                            title: FOOD_PROCESSING_ANIMAL_FEEDINGSTUFFS,
                            enum: [formatActivity("FOOD_PROCESSING_ANIMAL_FEEDINGSTUFFS")],
                        },
                        {
                            type: "string",
                            title: COSMETICS,
                            enum: [formatActivity("COSMETICS")],
                        },
                        {
                            type: "string",
                            title: HOME_CARE_DETERGENT_BIOCIDES_CANDLES,
                            enum: [formatActivity("HOME_CARE_DETERGENT_BIOCIDES_CANDLES")],
                        },
                        {
                            type: "string",
                            title: TOBACCO_ELIQUID,
                            enum: [formatActivity("TOBACCO_ELIQUID")],
                        },
                        {
                            type: "string",
                            title: LARGE_SCALE_RETAILING,
                            enum: [formatActivity("LARGE_SCALE_RETAILING")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_FINE_CHEMICALS,
                            enum: [formatActivity("CHEMICALS_FINE_CHEMICALS")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_PAINT_COATING,
                            enum: [formatActivity("CHEMICALS_PAINT_COATING")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_PETROCHEMISTRY,
                            enum: [formatActivity("CHEMICALS_PETROCHEMISTRY")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_PLASTICS,
                            enum: [formatActivity("CHEMICALS_PLASTICS")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_METALLURGY_CERAMICS,
                            enum: [formatActivity("CHEMICALS_METALLURGY_CERAMICS")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_FLAVOURING_FRAGRANCE,
                            enum: [formatActivity("CHEMICALS_FLAVOURING_FRAGRANCE")],
                        },
                        {
                            type: "string",
                            title: CHEMICALS_EXPLOSIVE,
                            enum: [formatActivity("CHEMICALS_EXPLOSIVE")],
                        },
                        {
                            type: "string",
                            title: TRANSPORT_AEROSPACE,
                            enum: [formatActivity("TRANSPORT_AEROSPACE")],
                        },
                        {
                            type: "string",
                            title: TRANSPORT_AUTOMOTIVE,
                            enum: [formatActivity("TRANSPORT_AUTOMOTIVE")],
                        },
                        {
                            type: "string",
                            title: HEALTH_PHARMACEUTICAL_MD,
                            enum: [formatActivity("HEALTH_PHARMACEUTICAL_MD")],
                        },
                        {
                            type: "string",
                            title: HEALTH_DIAGNOSIS_TEST_LABORATORY,
                            enum: [formatActivity("HEALTH_DIAGNOSIS_TEST_LABORATORY")],
                        },
                        {
                            type: "string",
                            title: DEFENCE_ARMAMENT_SECURITY,
                            enum: [formatActivity("DEFENCE_ARMAMENT_SECURITY")],
                        },
                        {
                            type: "string",
                            title: ENERGY,
                            enum: [formatActivity("ENERGY")],
                        },
                        {
                            type: "string",
                            title: ENVIRONMENT_RECYCLING,
                            enum: [formatActivity("ENVIRONMENT_RECYCLING")],
                        },
                        {
                            type: "string",
                            title: ENVIRONMENT_WATER_TREATMENT,
                            enum: [formatActivity("ENVIRONMENT_WATER_TREATMENT")],
                        },
                        {
                            type: "string",
                            title: CONSTRUCTION_MATERIALS,
                            enum: [formatActivity("CONSTRUCTION_MATERIALS")],
                        },
                        {
                            type: "string",
                            title: CONSTRUCTION_BUILDING_AND_PUBLIC_WORKS_INDUSTRY,
                            enum: [formatActivity("CONSTRUCTION_BUILDING_AND_PUBLIC_WORKS_INDUSTRY")],
                        },
                        {
                            type: "string",
                            title: ELECTRICAL_APPLIANCES,
                            enum: [formatActivity("ELECTRICAL_APPLIANCES")],
                        },
                        {
                            type: "string",
                            title: TELECOMMUNICATIONS,
                            enum: [formatActivity("TELECOMMUNICATIONS")],
                        },
                        {
                            type: "string",
                            title: ELECTRONICS,
                            enum: [formatActivity("ELECTRONICS")],
                        },
                        {
                            type: "string",
                            title: TRANSPORT_RAILWAYS,
                            enum: [formatActivity("TRANSPORT_RAILWAYS")],
                        },
                        {
                            type: "string",
                            title: TEXTILE,
                            enum: [formatActivity("TEXTILE")],
                        },
                    ],
                },
                country: {
                    type: "string",
                    title: `${COUNTRY}`,
                },
            },
        },
        uiSchema: {
            firstName: {
                "ui:widget": "text",
                "ui:options": {
                    semantic: {
                        fluid: true,
                        inverted: false,
                        size: "small",
                    },
                },
            },
            lastName: {
                classNames: "task-title foo-bar",
            },
            country: {
                "ui:field": "SelectCountry",
                "ui:options": { isNativeName: true },
            },
        },
        transformErrors: (errors) =>
            errors.map((e) => {
                if (e.name === "pattern" && e.property === ".email") {
                    e.message = "erreur de validation";
                }
                if (e.name === "required") {
                    e.message = "erreur required";
                }
                return e;
            }),
    };
};

const formatActivity = (activity: string) =>
    activity.replaceAll("_", "-").toLowerCase();

export type RegistrationType =
    | {
          email?: string | any;
          lastName?: string;
          firstName?: string;
          organization?: string;
          country?: string;
          job?: string;
          activityArea?: string;
      }
    | undefined;

const i18n = [
    `MedicalDevice.RegistrationForm.Email.label`,
    `MedicalDevice.RegistrationForm.Lastname.label`,
    `MedicalDevice.RegistrationForm.Firstname.label`,
    `MedicalDevice.RegistrationForm.Function.label`,
    `MedicalDevice.RegistrationForm.Organization.label`,
    `MedicalDevice.RegistrationForm.Activity.label`,
    `MedicalDevice.RegistrationForm.Country.label`,
];

const i18n_jobs = [
    "1Click.RegistrationForm.Function.manufacturing",
    "1Click.RegistrationForm.Function.sales",
    "1Click.RegistrationForm.Function.purchase",
    "1Click.RegistrationForm.Function.toxicology",
    "1Click.RegistrationForm.Function.ceo",
    "1Click.RegistrationForm.Function.regulatory",
    "1Click.RegistrationForm.Function.it",
    "1Click.RegistrationForm.Function.ehs",
    "1Click.RegistrationForm.Function.rd",
    "1Click.RegistrationForm.Function.quality",
];

const i18n_activity = [
    "1Click.RegistrationForm.Activity.foodProcessingSeedFruitVegetables",
    "1Click.RegistrationForm.Activity.foodProcessingDairy",
    "1Click.RegistrationForm.Activity.foodRocessingSugarIndustry",
    "1Click.RegistrationForm.Activity.foodProcessingGeneral",
    "1Click.RegistrationForm.Activity.foodProcessingAnimalFeedingstuffs",
    "1Click.RegistrationForm.Activity.cosmetics",
    "1Click.RegistrationForm.Activity.homeCareDetergentBiocidesCandles",
    "1Click.RegistrationForm.Activity.tobaccoEliquid",
    "1Click.RegistrationForm.Activity.largeScaleRetailing",
    "1Click.RegistrationForm.Activity.chemicalsFineChemicals",
    "1Click.RegistrationForm.Activity.chemicalsPaintCoating",
    "1Click.RegistrationForm.Activity.chemicalsPetrochemistry",
    "1Click.RegistrationForm.Activity.chemicalsPlastics",
    "1Click.RegistrationForm.Activity.chemicalsMetallurgyCeramics",
    "1Click.RegistrationForm.Activity.chemicalsFlavouringFragrance",
    "1Click.RegistrationForm.Activity.chemicalsExplosive",
    "1Click.RegistrationForm.Activity.transportAerospace",
    "1Click.RegistrationForm.Activity.transportAutomotive",
    "1Click.RegistrationForm.Activity.healthPharmaceuticalMd",
    "1Click.RegistrationForm.Activity.healthDiagnosisTestLaboratory",
    "1Click.RegistrationForm.Activity.defenceArmamentSecurity",
    "1Click.RegistrationForm.Activity.energy",
    "1Click.RegistrationForm.Activity.environmentRecycling",
    "1Click.RegistrationForm.Activity.environmentWaterTreatment",
    "1Click.RegistrationForm.Activity.constructionMaterials",
    "1Click.RegistrationForm.Activity.constructionBuildingAndPublicWorksIndustry",
    "1Click.RegistrationForm.Activity.electricalAppliances",
    "1Click.RegistrationForm.Activity.telecommunications",
    "1Click.RegistrationForm.Activity.electronics",
    "1Click.RegistrationForm.Activity.transportRailways",
    "1Click.RegistrationForm.Activity.textile",
];
